// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3H2-A","title":"styles_title__3Hyxr"};